function fnExternalLink(){
	return;// fix later
	function isExternal(url) {
	    var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
	    if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
	    if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"), "") !== location.host) return true;
	    return false;
	}


	$('body a').each(function(){
		var oThisA = $(this),
			sThisUrl = oThisA.attr('href');

		if(isExternal(sThisUrl)){
			oThisA.attr('target','parent');
		}
	});
}
